import { MAX_COMMUNITIES_TO_DISPLAY } from "@circleco/community-switcher/constants";

export const CommunitySwitcherLoading = ({
  length = MAX_COMMUNITIES_TO_DISPLAY,
}) => (
  <div
    aria-busy
    role="status"
    className="flex w-18 flex-col items-center gap-3.5 pt-5"
    data-testid="community-switcher-loading"
  >
    {Array.from({ length }).map((_, i) => (
      <div
        aria-hidden
        className="bg-tertiary size-9 animate-pulse rounded-md"
        key={`community-switcher-skeleton-${i}`}
      />
    ))}
  </div>
);
